import {Component, OnInit} from '@angular/core';
import {ModalController, NavParams} from '@ionic/angular';
import {IQApiResultObject} from '../../../interfaces/interfaces.regisafe';
import {APP_ICON_PATH, APP_ROUTES} from '../../../../environments/environment';
import {Router} from '@angular/router';
import {UserService} from '../../../provider/user/user.service';
import {StorageService} from '../../../provider/storage/storage.service';

@Component({
	selector: 'app-relation-list',
	templateUrl: './relation-list.component.html',
	styleUrls: ['./relation-list.component.scss'],
})
export class RelationListComponent implements OnInit {

	appIconPath = APP_ICON_PATH;
	relations: IQApiResultObject = {
		objDatasets: []
	};
	osId: string;
	meta: any;
	labels: any;
	up = true;
	hideSorting = true;
	iconpath: string;

	constructor(private modalCtrl: ModalController,
				private navParams: NavParams,
				private userService: UserService,
				private router: Router,
				private storageService: StorageService) {
	}

	async ngOnInit() {
		this.relations = this.navParams.data.relations;
		this.osId = this.navParams.data.osId;
		this.meta = this.navParams.data.meta;
		this.iconpath = this.userService.getExistingOrgastructIconOrDefault(this.meta.osId);
		this.labels = await this.storageService.getOsFieldDescFromConditions(this.meta.osId);
		this.hideSorting = !this.labels.hasOwnProperty('ADatum');
	}

	async closeModal() {
		await this.modalCtrl.dismiss(false);
	}

	async goToDetail(item, osId) {
		// eslint-disable-next-line no-underscore-dangle
		console.log('goToDetail: ', osId, item);

		// eslint-disable-next-line no-underscore-dangle
		this.router.navigate([APP_ROUTES.detail, osId, this.userService.objIdAsRouteParam(item._ObjId)])
			.then(async (data) => {
				console.log('this.router.navigate ###: ', data);
				await this.modalCtrl.dismiss(false);
			});
	}

	sort() {
		this.relations.objDatasets.sort((a, b) => {
			if (new Date(a.ADatum).getTime() < new Date(b.ADatum).getTime()) {
				this.up = false;
				return -1;
			}
			if (new Date(b.ADatum).getTime() < new Date(a.ADatum).getTime()) {
				this.up = true;
				return -1;
			}
			return 0;
		});
	}

}
